import { createAction } from '@reduxjs/toolkit';
import namespace from './namespace';

export const batchRecordDialog = createAction(`${namespace}/BATCH_RECORD_DIALOG`);
export const batchRecordDialogOpen = createAction(`${namespace}/BATCH_RECORD_DIALOG_OPEN`);
export const batchRecordDialogClose = createAction(`${namespace}/BATCH_RECORD_DIALOG_CLOSE`);
